import { StandardButton } from "../atoms/buttons"
import { IconAtom } from "../atoms/iconAtom"
import { StandardComp } from "../atoms/standardComp"

export const MultipleChoice = ({ answers, clickAnswer }) => {
    return (
        <div className="vertical answers-div" style={{ width: 'unset', gap:"1rem" }}>
            {answers.map((answer, index) => {
                return (
                    <StandardComp
                        editClass={answer.chosen && "active-standard"}
                        onClick={() => clickAnswer(index)}

                        style={{  padding: "0.5rem", marginRight:"unset" }}
                        content={
                            <div className="horizontal multiplechoice-button">
                                <div className="check-circle">
                                  { answer.chosen && <IconAtom
                                        icon2={"check"}
                                    />}
                                </div>
                                <p className="standard-text-color">{answer.quiz_answer}</p>
                            </div>
                        }
                    />
                )
            })}
        </div>
    )
}